<template>
  <v-snackbar 
    v-model   = "show"
    :color    = "color"
  >
    <v-layout 
      class     = "snack-container"
      align-center
      pr-4
    >
      <v-icon 
        v-if  = "icon"
        class = "pr-3"
        dark
      >
        {{ icon }}
      </v-icon>
      <div class="message">{{ message }}</div>
    </v-layout>

    <template v-slot:action="{ attrs }">
      <v-btn 
        text 
        v-bind    = "attrs" 
        @click    = "show = false"
      >
        Dismiss
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="js">

export default {

  // #region Properties

  name: 'SnacksPane',
  data() {
    return {
      show:    false,
      message: '',
      color:   ''
    }
  },
  computed: {
    icon() {
      switch (this.color) {
      case 'error':   return 'mdi-alert-octagon';
      case 'info':    return 'mdi-information';
      case 'success': return 'mdi-check';
      case 'warning': return 'mdi-alert';
      default:        return undefined;
      }
    }
  },

  // #endregion Properties

  // #region Life-Cycle

  created() {
    this.$store.watch(
      state => state.snack.snack,
      (snack) => {
        this.message = snack.message;
        this.color = snack.level;
        this.show = true;
      }
    )
  }

  // #endregion Life-Cycle

}
</script>

<style scoped>

.snack-container .message {
  max-width:    500px;
  word-wrap:    break-word;
}

</style>